import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { organizationDetail } from "../Context/SelectedOrganization";
import CommanPagination from "../pages/common/CommanPagination/CommanPagination";
import AddUserRoleModal from "../pages/common/UserRole/AddUserRoleModal";
import axiosClient from "../Services/Axios/axios";
import { BeatLoader } from "react-spinners";
import DateFormatter from "../pages/common/DateFormatter/DateFormatter";
import SellerSidebar from "./common/SellerSidebar";

function UserRole() {
  const { organizationData } = useContext(organizationDetail);
  const [loader, setLoader] = useState(false);
  const [modalType, setModalType] = useState("add");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [editRoleData, setEditRoleData] = useState({});
  const [limit, setLimit] = useState(8);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);

  const ManageAccess = (role) => {
    navigate(
      `/employee-role/manage-access-control/${role.id}`,

      {
        state: {
          data: role,
        },
      }
    );
  };
  const handleClose1 = () => {
    setIsModalOpen(false);
  };

  const handleOpen1 = () => {
    setIsModalOpen(true);
  };
  const handleEdit = (role) => {
    setEditRoleData(role);
    setModalType("edit");
    setIsModalOpen(true);
  };
  const getUserList = async () => {
    // Your API call logic here
    try {
      setLoader(true);
      const response = await axiosClient.get(
        `employees/${
          process.env.REACT_APP_API_VERSION
        }/role/role-lists?organization_id=${sessionStorage.getItem(
          "organization_id"
        )}&search=${searchQuery}`
      );
      if (!response.data.error) {
        setLoader(false);
        setRoles(response.data.data);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    setCurrentPage(1);
    getUserList();
  }, [searchQuery, limit, organizationData]);

  return (
    <>
      <div className="all_suport_bg manages_top">
        <section className="ser_v_araeea profiles">
          <div className="container">
            <div className="bradcams">
              <span className="bothss">
                <Link to="/dashboard">Dashboard</Link>{" "}
                <img src="/images/brd_rowwo.png" alt="" /> Employee Role
              </span>
            </div>
            <div className="row">
              <div className="col-lg-3 mb_view_hide">
                <SellerSidebar />
              </div>

              <div className="col-lg-9 order-list">
                <div
                  className="d-flex justify-content-between align-items-center mb-3"
                  style={{ gap: "12px" }}
                >
                  <h4 style={{ fontWeight: "600" }}>Employee Role</h4>
                  {/* Left: Search + Filter */}
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "8px" }}
                  >
                    <div
                      className=""
                      style={{ position: "relative", width: "250px" }}
                    >
                      <input
                        type="text"
                        className="search-input "
                        placeholder="Search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      <img
                        src="/images/search.png"
                        alt="search"
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          width: "25px",
                          height: "24px",
                          cursor: "pointer",
                        }}
                      />
                    </div>
                    {/* <button className="btn-filter">
                      <img src="/images/controls-alt.png" alt="filter" />
                    </button> */}
                  </div>
                </div>

                {/* Order List */}
                <div className="form_boxx profilss">
                  <div className="form_arar mt-0">
                    <div className="d-flex justify-content-between mb-3">
                      <h5>Employee Role</h5>
                      {/* <a href="">View All</a> */}
                      <button onClick={handleOpen1} className="ad_butto">
                        + Add Role
                      </button>
                    </div>
                    {/* Scroll wrapper */}
                    <div style={{ overflowX: "auto" }}>
                      <table className="orders-table">
                        <thead>
                          <tr className="table-header">
                            <th className="header-cell">S. No.</th>
                            <th className="header-cell">Role type</th>
                            <th className="header-cell">Created</th>
                            <th className="header-cell">Access Control </th>
                            <th className="header-cell">Status</th>
                            <th className="header-cell">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* Loader Centered */}
                          {loader && (
                            <tr>
                              <td colSpan="6">
                                <div className="loader-center">
                                  <BeatLoader color="#097C81" />
                                </div>
                              </td>
                            </tr>
                          )}

                          {/* No Data Found */}
                          {!loader &&
                            (!roles?.rows || roles.rows.length === 0) && (
                              <tr>
                                <td colSpan="6">
                                  <div className="no-data-center">
                                    No Data Found
                                  </div>
                                </td>
                              </tr>
                            )}

                          {/* Table Rows */}
                          {!loader &&
                            roles?.rows?.length > 0 &&
                            roles.rows.map((role, index) => (
                              <tr key={role.id} className="table-row">
                                <td className="table-cell serial-number">
                                  {(currentPage - 1) * limit + index + 1}.
                                </td>

                                <td className="table-cell">{role.role_name}</td>

                                <td className="table-cell">
                                  {DateFormatter(role.created_at)}
                                </td>

                                <td className="table-cell">
                                  <button
                                    className="btn-access"
                                    onClick={() => ManageAccess(role)}
                                  >
                                    Manage Access Control
                                  </button>
                                </td>

                                <td
                                  className={`table-cell status ${
                                    role.status === 0
                                      ? "status-pending"
                                      : "status-confirmed"
                                  }`}
                                >
                                  {role.status === 0 ? "Pending" : "Confirmed"}
                                </td>

                                <td className="table-cell action">
                                  <div
                                    className="flexx"
                                    style={{ justifyContent: "center" }}
                                  >
                                    <img
                                      className="action-btn edit-btn"
                                      src="/images/edit_views.png"
                                      alt="edit"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleEdit(role)}
                                    />
                                  </div>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                {/* Pagination */}
                <div className="pages_liststs">
                  <CommanPagination
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    limit={limit}
                    totalCounts={roles.totalElement}
                    totalPage={roles.totalPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AddUserRoleModal
        isModalOpen={isModalOpen}
        handleClose1={handleClose1}
        getUserList={getUserList}
        modalType={modalType}
        editRoleData={editRoleData}
      />
    </>
  );
}

export default UserRole;
